import React from 'react';
import { useContent } from '../../hooks/useContent';
import { uploadsAbsoluteUrl } from '../../utils/uploadsBase';
import { editorialBoardEn } from '../../content/editorialBoardEn';
import styles from './EditorialBoard.module.css';

const MEMBER_IDS = ['m1', 'm2', 'm3', 'm4'];

export default function EditorialBoard() {
  const { t } = useContent();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  const def = editorialBoardEn;

  const imgSrc = (memberId) => {
    const d = def.members[memberId] || {};
    const path = t(`editorialBoard.members.${memberId}.img`, d.img ?? '');
    if (!path) return d.img || '';
    const s = String(path);
    if (s.startsWith('http://') || s.startsWith('https://')) return s;
    if (s.startsWith('/uploads')) return uploadsAbsoluteUrl(s, API_URL);
    return s;
  };

  return (
    <div className={styles.page}>
      <div className={styles.titleSection}>
        <h1>{t('editorialBoard.pageTitle', def.pageTitle)}</h1>
      </div>

      <div className={styles.boardSection}>
        <div className={styles.grid}>
          {MEMBER_IDS.map((mid) => {
            const d = def.members[mid] || {};
            const name = t(`editorialBoard.members.${mid}.name`, d.name ?? '');
            const rank = t(`editorialBoard.members.${mid}.rank`, d.rank ?? '');
            const desc = t(`editorialBoard.members.${mid}.desc`, d.desc ?? '');
            const email = t(`editorialBoard.members.${mid}.email`, d.email ?? '');
            return (
              <div key={mid} className={styles.card}>
                <img src={imgSrc(mid)} alt={name} className={styles.image} />
                <div className={styles.body}>
                  <h2>{name}</h2>
                  <p className={styles.rank}>{rank}</p>
                  <p className={styles.desc}>{desc}</p>
                  <p className={styles.email}>{email}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
